import { useContext } from 'react';

import Text from 'components/common/Text';
import PickYourMealsCheckMark from 'components/icons/PickYourMealsCheckMark';
import { UserContext } from 'components/signUpFunnel/Contexts';
import { BrandContext } from 'context/BrandContext';

import CutOffDateAndTime from './CutOffDateAndTime';
import DashedHorizontalLine from './DashedHorizontalLine';
import DashedVerticalLine from './DashedVerticalLine';
import ThankYouButton from './ThankYouButton';

const PickYourMealsHero = ({ onContinue }) => {
  const { postSignupUrl } = useContext(BrandContext);
  const { user } = useContext(UserContext);

  return (
    <div className="flex flex-col items-center bg-tempo-gray-100 p-6 text-center bp2:py-12">
      <Text brandStylesOverrides="h1">Nice! Here’s What’s Next</Text>
      <Text brandStylesOverrides="textMd mb-1 bp1:h5 bp1:mb-2" className="mt-2 text-charcoal-90">
        Finish setting up your subscription:
      </Text>
      <div className="mb-4 mt-10 flex flex-col items-center gap-4 bp2:gap-0">
        <div className="flex w-full flex-col items-center bp2:flex-row bp2:items-center bp2:justify-center bp2:pb-32">
          <div className="flex w-full flex-row bp2:relative bp2:w-auto bp2:flex-col bp2:items-center">
            <div className="flex flex-col items-center">
              <PickYourMealsCheckMark checked={true} />
              {/* Mobile: vertical dashed line under checkmark */}
              <span className="block bp2:hidden">
                <DashedVerticalLine color="bg-tempo-black-100" />
              </span>
            </div>
            {/* Mobile: text right, Desktop: absolute below */}
            <div className="ml-3 flex-1 bp2:absolute bp2:left-1/2 bp2:top-full bp2:ml-0 bp2:mt-2 bp2:w-64 bp2:-translate-x-1/2">
              <div className="flex w-3/4 flex-col items-start bp2:w-full bp2:items-center">
                <Text brandStylesOverrides="textMd mb-1 bp1:h5 bp1:mb-2">
                  First Order Scheduled 🎉
                </Text>
                <CutOffDateAndTime textStyles="text-left bp2:text-center" />
              </div>
            </div>
          </div>
          {/* Desktop: horizontal dashed line */}
          <span className="hidden bp2:block">
            <DashedHorizontalLine color="bg-tempo-black-100" />
          </span>
          <div className="flex w-full flex-row bp2:relative bp2:w-auto bp2:flex-col bp2:items-center">
            <div className="flex flex-col items-center">
              <PickYourMealsCheckMark />
              {/* Mobile: vertical dashed line under checkmark */}
              <span className="block bp2:hidden">
                <DashedVerticalLine color="bg-charcoal-70" />
              </span>
            </div>
            <div className="ml-3 flex-1 bp2:absolute bp2:left-1/2 bp2:top-full bp2:ml-0 bp2:mt-2 bp2:w-64 bp2:-translate-x-1/2">
              <div className="flex flex-col items-start bp2:items-center">
                <Text brandStylesOverrides="textMd mb-1 bp1:h5 bp1:mb-2">
                  Complete Account Setup
                </Text>
                <Text>Set Password</Text>
              </div>
            </div>
          </div>
          {/* Desktop: horizontal dashed line */}
          <span className="hidden bp2:block">
            <DashedHorizontalLine color="bg-charcoal-70" />
          </span>
          <div className="flex w-full flex-row bp2:relative bp2:w-auto bp2:flex-col bp2:items-center">
            <div className="flex flex-col items-center">
              <PickYourMealsCheckMark />
            </div>
            <div className="ml-3 flex-1 bp2:absolute bp2:left-1/2 bp2:top-full bp2:ml-0 bp2:mt-2 bp2:w-64 bp2:-translate-x-1/2">
              <div className="flex w-3/4 flex-col items-start bp2:w-full bp2:items-center">
                <Text brandStylesOverrides="textMd mb-1 bp1:h5 bp1:mb-2">
                  Enjoy Weekly Deliveries!
                </Text>
                <Text className="text-left bp2:text-center">
                  Edit your scheduled orders up to 5 weeks in advance!
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full">
        <ThankYouButton
          variant="primary"
          postSignupUrl={postSignupUrl}
          user={user}
          onClick={onContinue}
          buttonStyles="w-full bp1:w-auto"
        />
        <Text className="text-charcoal-90">Skip, pause, or cancel any time.</Text>
      </div>
    </div>
  );
};

PickYourMealsHero.propTypes = {
  onContinue: PropTypes.func.isRequired,
};

export default PickYourMealsHero;
